import React, { Component } from "react";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import {
  getProjectUsers,
  removeProjectUser,
  updateProjectUser,
} from "../../../../services/projectService";
import { getRoles, getUsers } from "../../../../services/userService";
import CustomLoader from "../../../common/Loader";
import AddProjectUser from "./AddProjectUserDialog";
import { logActivity } from '../../../../services/utilService';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FormAccessDialog from "./FormAccessDialog";
import AccessActionMenu from "./AccessActionMenu";
import Select from "react-select";

class ProjectUsers extends Component {
  state = {
    //Project_ID: this.props.Project_ID,
    Project_Users: [],
    User_Options: [],
    Roles: [],
    loading: true,
    isFormAccessModalOpen: false,
  };

  async loadUsers() {
    const { data: Project_Users } = await getProjectUsers(
      this.props.Project_ID
    );

    let { data: User_Options } = await getUsers();
    User_Options = User_Options.filter((user) => {
      return (
        Project_Users.filter((puser) => puser.User_ID === user.User_ID)
          .length !== 1
      );
    });

    this.setState({ User_Options });
    this.setState({ Project_Users });

    return Project_Users
  }

  async componentDidMount() {
    const Project_Users = await this.loadUsers();

    let { data: Roles } = await getRoles();
    Roles = Roles.filter(
      (role) => role.Role_Level !== 1 && role.Role_Level !== 999
    );
    
    Project_Users.forEach((user, idx) => {
      let roleArray = []
      if (user['Role_List'] !== '') {
        user['Role_List'].split(',').forEach(role_id => {
          let label = Roles.filter(role => parseInt(role['Role_ID']) === parseInt(role_id))[0]
          roleArray.push({ value: parseInt(role_id), label: label === undefined ? '' : label['Role_Name']})
        })
      }
      Project_Users[idx]['Role_List'] = roleArray
    })

    let Parsed_Roles = []
    Roles.forEach(role => {
      Parsed_Roles.push({ value: parseInt(role['Role_ID']), label: role['Role_Name']})
    })

    this.setState({ Project_Users, Roles: Parsed_Roles });
    
    this.setState({ loading: false });
  }

  handleChange = async (role, idx) => {
    let Project_Users = [...this.state.Project_Users];
    const { data } = await updateProjectUser(
      Project_Users[idx].Record_ID,
      role
    );

    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_USER_UPDATE_FAILED');
    } else {
      toaster('success', 'Updated');
      logActivity('/projectSettings', 'PROJECT_USER_UPDATE_SUCCESS');
      Project_Users[idx].Role_ID = role;
      this.setState({ Project_Users });
    }
  };

  handleDelete = async (User_ID, Project_ID) => {
    const { data } = await removeProjectUser(parseInt(User_ID), parseInt(Project_ID));
    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_USER_DELETE_FAILED');
    } else {
      let { Project_Users } = this.state;
      Project_Users = Project_Users.filter((user) => user.User_ID !== User_ID);
      this.setState({ Project_Users });
      toaster('success', 'Removed');
      logActivity('/projectSettings', 'PROJECT_USER_DELETE_SUCCESS');
      // window.location.reload()
    }
  };

  handleAdd = async (user, role_list) => {
    const { data } = await updateProjectUser(
      role_list,
      user,
      this.props.Project_ID
    );

    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_USER_CREATE_FAILED');
    } else {
      this.loadUsers();
      toaster('success', data);
      logActivity('/projectSettings', 'PROJECT_USER_CREATE_SUCCESS');
    }
  };

  changeRoleValue = async (userIdx, roleValue) => {
    let { Project_Users } = this.state;
    if(userIdx >= 0) {
      const { data } = await updateProjectUser(
        roleValue === null ? [] : roleValue,
        Project_Users[userIdx].User_ID,
        this.props.Project_ID
      )
      if (data.includes("Error")) {
        toaster('error', data)
        logActivity('/projectSettings', 'PROJECT_USER_UPDATE_FAILED')
      } else {
        toaster('success', 'Updated')
        logActivity('/projectSettings', 'PROJECT_USER_UPDATE_SUCCESS')
        Project_Users[userIdx]['Role_List'] = roleValue === null ? [] : roleValue;
        this.setState({ Project_Users })
      }
    }
  }

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }

    const { Project_Users, Roles, User_Options } = this.state;
    return (
      <React.Fragment>
        <AddProjectUser
          Users={User_Options}
          Roles={Roles}
          handleAdd={this.handleAdd}
        />
        <table className="table table-hover table-borderless">
          <thead className="border-bottom">
            <tr>
              <th>User</th>
              <th>Username</th>
              <th>Role</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {Project_Users.map((user, idx) => (
              <tr className="border-bottom" key={"projectUser" + user.User_ID}>
                <td>{user.Name}</td>
                <td>{user.Username}</td>
                <td>
                  <Select
                    isMulti
                    isDisabled={false}
                    options={Roles}
                    name='Roles'
                    onChange={this.changeRoleValue.bind(null, idx)}
                    placeholder='Select Roles...'
                    value={user["Role_List"]}
                  />
                </td>
                <td>
                  <AccessActionMenu
                      user={user}
                      handleDelete={this.handleDelete}
                      Project_ID={this.props.Project_ID}
                  />
                </td>
                {/*<td>*/}
                {/*  <button*/}
                {/*    className="btn btn-outline-danger btn-sm rounded-0"*/}
                {/*    onClick={() => this.handleRemove(user.Record_ID)}*/}
                {/*  >*/}
                {/*    Remove*/}
                {/*  </button>*/}
                {/*</td>*/}
              </tr>
            ))}
          </tbody>
        </table>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default ProjectUsers;
